module.exports = __webpack_public_path__ + "static/img/bg_1.2612660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_1.png
// module id = hb6x
// module chunks = 1